import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowFullUp = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M20 32.4615V8.92307",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "square",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M32 20L20 8L8 20",
		stroke: "currentColor",
		strokeWidth: 2
	})]
});
const ForwardRef = forwardRef(SvgArrowFullUp);
export default ForwardRef;
